var DEFAULT_FONT_FAMILY = "\"Helvetica Neue\",Helvetica, Arial, sans-serif,\n\"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"";
/**
 * 获取
 */
function getLetterSpacing(tracking, fontSize) {
    return tracking / (fontSize * 16) + "em";
}
var getDefaultTypography = function (fontWeightLight, fontWeightRegular, fontWeightMedium, fontFamily, palette) { return ({
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontFamily: fontFamily,
    display4: {
        fontSize: 7,
        fontWeight: fontWeightLight,
        fontFamily: fontFamily,
        lineHeight: 7.25,
        color: palette.text.primary,
        letterSpacing: getLetterSpacing(-1.5, 6),
    },
    display3: {
        fontSize: 3.5,
        fontWeight: fontWeightRegular,
        fontFamily: fontFamily,
        lineHeight: 4.125,
        color: palette.text.primary,
        letterSpacing: getLetterSpacing(-0.5, 3.75),
    },
    display2: {
        fontSize: 2.8125,
        fontWeight: fontWeightRegular,
        fontFamily: fontFamily,
        lineHeight: 3.25,
        color: palette.text.primary,
        letterSpacing: 'normal',
    },
    display1: {
        fontSize: 2.125,
        fontWeight: fontWeightRegular,
        fontFamily: fontFamily,
        lineHeight: 2.5,
        color: palette.text.primary,
        letterSpacing: getLetterSpacing(0.25, 2.125),
    },
    headline: {
        fontSize: 1.5,
        fontWeight: fontWeightRegular,
        fontFamily: fontFamily,
        lineHeight: 2,
        color: palette.text.primary,
        letterSpacing: 'normal',
    },
    title: {
        fontSize: 1.25,
        fontWeight: fontWeightMedium,
        fontFamily: fontFamily,
        lineHeight: 1.75,
        color: palette.text.primary,
    },
    subheading: {
        fontSize: 1,
        fontWeight: fontWeightRegular,
        fontFamily: fontFamily,
        lineHeight: 1.5,
        color: palette.text.primary,
    },
    body2: {
        fontSize: 0.875,
        fontWeight: fontWeightMedium,
        fontFamily: fontFamily,
        lineHeight: 1.5,
        color: palette.text.primary,
    },
    body1: {
        fontSize: 0.875,
        fontWeight: fontWeightRegular,
        fontFamily: fontFamily,
        lineHeight: 1.5,
        color: palette.text.primary,
        letterSpacing: getLetterSpacing(0.25, 0.875),
    },
    caption: {
        fontSize: 0.75,
        fontWeight: fontWeightRegular,
        fontFamily: fontFamily,
        lineHeight: 0.875,
        color: palette.text.secondary,
    },
    button: {
        fontSize: 0.875,
        fontWeight: fontWeightMedium,
        fontFamily: fontFamily,
        lineHeight: 'normal',
        color: palette.text.primary,
    },
}); };
/**
 * 创建文本主题
 *
 * @param palette 调色板
 * @param constants 文本主题配置
 */
export default function createTypography(palette, constants) {
    if (constants === void 0) { constants = {}; }
    var _a = constants.fontFamily, fontFamily = _a === void 0 ? DEFAULT_FONT_FAMILY : _a, _b = constants.fontSize, fontSize = _b === void 0 ? 0.875 : _b, _c = constants.fontWeightLight, fontWeightLight = _c === void 0 ? '300' : _c, _d = constants.fontWeightRegular, fontWeightRegular = _d === void 0 ? '400' : _d, _e = constants.fontWeightMedium, fontWeightMedium = _e === void 0 ? '500' : _e;
    var theme = getDefaultTypography(fontWeightLight, fontWeightRegular, fontWeightMedium, fontFamily, palette);
    Object.keys(theme).forEach(function (key) {
        if (constants[key]) {
            theme[key] = constants[key];
        }
    });
    return theme;
}
//# sourceMappingURL=typography.js.map